import client from '@/http'

const loadAll = (context) => {
  client.get(
    'column-categories'
  ).then(
    (res) => {
      context.commit('SET_COLUMN_CATEGORIES', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadTree = (context) => {
  client.get(
    'column-categories/tree'
  ).then(
    (res) => {
      context.commit('SET_COLUMN_CATEGORIES_TREE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const save = (context, params) => {
  if (params.id) {
    client.put(
      `column-categories/${params.id}`, params
    ).then(
      () => {
        context.commit('UPDATE', params)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  } else {
    client.post(
      'column-categories', params
    ).then(
      (res) => {
        context.commit('PUSH', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }
}

export default {
  save,
  loadAll,
  loadTree
}
